import { EasmScanConfigurationNirvanaDataProvider } from '../dataProvider/EasmScanConfigurationNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ, API_TYPE_NIRVANA } from '../../../../webcomponents.constants';

export class EasmScanConfigurationDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, EasmScanConfigurationNirvanaDataProvider);
    this.map.set(API_TYPE_NIRVANA, EasmScanConfigurationNirvanaDataProvider);
  }
}
